import { API } from "aws-amplify";
import { listParcels } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getParcelList = async ({
  ownerID,
  ownerType,
  propertyID,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  propertyID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Parcel[]>> => {
  const filters: GRAPHQLFilters = getGraphqlFilters({
    propertyID,
    ownerID,
    ownerType,
  });

  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }

  let items: APITypes.Parcel[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      const response = (await API.graphql({
        query: listParcels,
        variables: {
          filter: Object.keys(filters).length > 0 ? filters : undefined,
          limit: 100,
          nextToken,
        },
      })) as {
        data?: APITypes.ListParcelsQuery;
      };

      const parcels =
        response.data?.listParcels?.items?.filter(
          (item): item is APITypes.Parcel =>
            item !== null &&
            (includeDeleted === "all" ||
              (includeDeleted === "only"
                ? item._deleted === true
                : item._deleted !== true)),
        ) ?? [];
      items.push(...parcels);
      nextToken = response.data?.listParcels?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    console.error("Error fetching parcel list:", error);
    return {
      success: false,
      data: [],
      error,
    };
  }
};
